import React from "react";
import { t } from "ttag";

import {
    ImageWithCaptionBlock,
    ScrollingImageGalleryBlock as Value,
} from "@reactivated";

import { notEmptyOrBlank } from "@thelabnyc/thelabui/src/utils/functional";

import { ListCarousel } from "../Carousel/ListCarousel";
import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

const Item = ({ media, content }: ImageWithCaptionBlock) => {
    return (
        <div className={styles.item}>
            {media && media.length > 0 ? (
                <MediaChooserBlock
                    wrapperAttrs={{ className: styles.media }}
                    value={media}
                    type="background"
                />
            ) : null}
            {content && (
                <RichText value={content} className={styles.richText} />
            )}
        </div>
    );
};

const slidesVisibleMobile = 1.25;

interface CustomCss extends React.CSSProperties {
    "--slides-visible-mobile": number;
}

interface Props {
    value: Value;
    id?: string;
}

export const ScrollingImageGalleryBlock = ({
    value: { header_content, images, theme },
    id: propId,
}: Props) => {
    if (!images || images.length === 0) return <></>;

    const id = propId || "scrolling-image-gallery";

    return (
        <section
            className={styles[theme ?? "match"]}
            style={
                {
                    "--slides-visible-mobile": slidesVisibleMobile,
                } as CustomCss
            }
        >
            <div className={styles.grid}>
                <div className={styles.header}>
                    {header_content && <RichText value={header_content} />}
                </div>
                <div className={styles.images}>
                    {images.map((item, index) => (
                        <Item {...item} key={`${id}-${index}`} />
                    ))}
                </div>
                <ListCarousel
                    label={t`Image Gallery`}
                    navigationProps={{ className: styles.nav }}
                    wrapperAttrs={{ className: styles.carousel }}
                    listItemAttrs={{ className: styles.listItem }}
                    progressClassName={styles.progressBar}
                >
                    {images.filter(notEmptyOrBlank).map((item, index) => (
                        <Item {...item} key={`${id}-${index}`} />
                    ))}
                </ListCarousel>
            </div>
        </section>
    );
};
